import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ADD_SUPPLIER_PATH } from '@app/constants';
import { useNewUserAccessRights } from '@app/hooks';

export const useSuppliersHeader = () => {
  const navigate = useNavigate();

  const {
    userAccessRights: {
      Warehouse: { IsSupplierCreate },
    },
  } = useNewUserAccessRights();

  const goToAddSupplier = useCallback(
    () => navigate(ADD_SUPPLIER_PATH),
    [navigate]
  );

  return { goToAddSupplier, IsSupplierCreate };
};
